export const ContactIconUserTypes = {
    Default: 'default',
    External: 'external',
    Internal: 'internal',
    Agent: 'agent',
    Supervisor: 'supervisor',
    EndCustomer: 'end-customer',
    Unknown: 'unknown',
    Green: 'green',
} as const;

export const UnknownCustomer = 'Unknown';

export type ContactIconUser =
    (typeof ContactIconUserTypes)[keyof typeof ContactIconUserTypes];
